/**
 * Generated by orval v7.11.2 🍺
 * Do not edit manually.
 * Supervizor APIs
 * Here is the list of the API endpoints of Supervizor. Click on one to display its implementation. 

Some APIs are protected and require a Bearer token in the Authorization header
 * OpenAPI spec version: 1.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  CreateAccessControlRequestDto,
  CreateAccessControlResponseDto,
  FindAccessControlsParams,
  GetAccessControlListResponseDto
} from '.././model';

import { customAxiosInstance } from '../../axios/axiosInstance';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



/**
 * @summary Create a new access control
 */
export const createAccessControl = (
    createAccessControlRequestDto: CreateAccessControlRequestDto,
 options?: SecondParameter<typeof customAxiosInstance>,signal?: AbortSignal
) => {
      
      
      return customAxiosInstance<CreateAccessControlResponseDto>(
      {url: `/access-controls`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createAccessControlRequestDto, signal
    },
      options);
    }
  


export const getCreateAccessControlMutationOptions = <TError = null | null,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createAccessControl>>, TError,{data: CreateAccessControlRequestDto}, TContext>, request?: SecondParameter<typeof customAxiosInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof createAccessControl>>, TError,{data: CreateAccessControlRequestDto}, TContext> => {

const mutationKey = ['createAccessControl'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createAccessControl>>, {data: CreateAccessControlRequestDto}> = (props) => {
          const {data} = props ?? {};

          return  createAccessControl(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CreateAccessControlMutationResult = NonNullable<Awaited<ReturnType<typeof createAccessControl>>>
    export type CreateAccessControlMutationBody = CreateAccessControlRequestDto
    export type CreateAccessControlMutationError = null | null

    /**
 * @summary Create a new access control
 */
export const useCreateAccessControl = <TError = null | null,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createAccessControl>>, TError,{data: CreateAccessControlRequestDto}, TContext>, request?: SecondParameter<typeof customAxiosInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createAccessControl>>,
        TError,
        {data: CreateAccessControlRequestDto},
        TContext
      > => {

      const mutationOptions = getCreateAccessControlMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    /**
 * @summary Find access controls by filters
 */
export const findAccessControls = (
    params?: FindAccessControlsParams,
 options?: SecondParameter<typeof customAxiosInstance>,signal?: AbortSignal
) => {
      
      
      return customAxiosInstance<GetAccessControlListResponseDto>(
      {url: `/access-controls`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getFindAccessControlsQueryKey = (params?: FindAccessControlsParams,) => {
    return [`/access-controls`, ...(params ? [params]: [])] as const;
    }

    
export const getFindAccessControlsQueryOptions = <TData = Awaited<ReturnType<typeof findAccessControls>>, TError = null | null | null>(params?: FindAccessControlsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findAccessControls>>, TError, TData>>, request?: SecondParameter<typeof customAxiosInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getFindAccessControlsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof findAccessControls>>> = ({ signal }) => findAccessControls(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof findAccessControls>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type FindAccessControlsQueryResult = NonNullable<Awaited<ReturnType<typeof findAccessControls>>>
export type FindAccessControlsQueryError = null | null | null


export function useFindAccessControls<TData = Awaited<ReturnType<typeof findAccessControls>>, TError = null | null | null>(
 params: undefined |  FindAccessControlsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof findAccessControls>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof findAccessControls>>,
          TError,
          Awaited<ReturnType<typeof findAccessControls>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxiosInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFindAccessControls<TData = Awaited<ReturnType<typeof findAccessControls>>, TError = null | null | null>(
 params?: FindAccessControlsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findAccessControls>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof findAccessControls>>,
          TError,
          Awaited<ReturnType<typeof findAccessControls>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxiosInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFindAccessControls<TData = Awaited<ReturnType<typeof findAccessControls>>, TError = null | null | null>(
 params?: FindAccessControlsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findAccessControls>>, TError, TData>>, request?: SecondParameter<typeof customAxiosInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Find access controls by filters
 */

export function useFindAccessControls<TData = Awaited<ReturnType<typeof findAccessControls>>, TError = null | null | null>(
 params?: FindAccessControlsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findAccessControls>>, TError, TData>>, request?: SecondParameter<typeof customAxiosInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getFindAccessControlsQueryOptions(params,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * @summary Delete access control by id
 */
export const deleteAccessControlById = (
    id: string,
 options?: SecondParameter<typeof customAxiosInstance>,) => {
      
      
      return customAxiosInstance<null>(
      {url: `/access-controls/${id}`, method: 'DELETE'
    },
      options);
    }
  


export const getDeleteAccessControlByIdMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteAccessControlById>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customAxiosInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteAccessControlById>>, TError,{id: string}, TContext> => {

const mutationKey = ['deleteAccessControlById'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteAccessControlById>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  deleteAccessControlById(id,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteAccessControlByIdMutationResult = NonNullable<Awaited<ReturnType<typeof deleteAccessControlById>>>
    
    export type DeleteAccessControlByIdMutationError = unknown

    /**
 * @summary Delete access control by id
 */
export const useDeleteAccessControlById = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteAccessControlById>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customAxiosInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteAccessControlById>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getDeleteAccessControlByIdMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    